import { Component, OnInit, OnDestroy, HostListener, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AuthenticatedUser } from './shared/authenticated-user.model';
import { MsalBroadcastService, MsalGuardConfiguration, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult,  InteractionStatus, PopupRequest, RedirectRequest,EventMessage, EventType } from '@azure/msal-browser';
import { BulkRequestComponent } from './bulkrequest/bulk-request/bulk-request.component';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  url: string;
  title = 'MIBAT';
  limit!: Date;
  subscriptions!: Subscription[];


  inactivityInterval: any;
  inactivityLimitMin!: number;
  inactivityLimitTimestamp!: Date;

  breadCrumb!: string;
  verifyingDbUser = false;
  dbUserIsVerified = false;
  isIE = false;
  showDebug = false;
  keyDownCodes = [];
  isUserAuthErrorCondition = false;
  isIframe = false;
  isUserAuthenticated = false;
  userProfile!: AuthenticatedUser;
  profileFetchInProgress = false;
  isInitialized = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
  private broadcastService: MsalBroadcastService,
  private msalService: MsalService,
    private router: Router,) {
    this.url = window.location.href;

    if (localStorage.length <= 3) {
      this.router.navigate(['/']);
    }
    this.resetTimeout();
        setInterval(() => {
            if (new Date() >= this.limit) {
                let request = new XMLHttpRequest();
                request.open('GET', './assets/app-config.json', false);
                request.send(null);
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = JSON.parse(request.responseText).logoutUrl;
            }
        }, 10000);
  } 
  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
    this.setLoginDisplay();
    this.broadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
       this.isInitialized = true;
      })
  }
  setLoginDisplay() {
    this.isUserAuthenticated = this.msalService.instance.getAllAccounts().length > 0;
  }
  

  checkAndSetActiveAccount() {
    let activeAccount = this.msalService.instance.getActiveAccount();

    if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
      let accounts = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.msalService.loginRedirect();
    }
  }

  loginPopup() {
    if (this.msalGuardConfig.authRequest) {
      this.msalService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        .subscribe((response: AuthenticationResult) => {
          this.msalService.instance.setActiveAccount(response.account);
        });
    } else {
      this.msalService.loginPopup()
        .subscribe((response: AuthenticationResult) => {
          this.msalService.instance.setActiveAccount(response.account);
        });
    }
  }

  logout(popup?: boolean) {
    if (popup) {
      this.msalService.logoutPopup({
        mainWindowRedirectUri: "/"
      });
    } else {
      this.msalService.logoutRedirect();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe());
    this._destroying$.next(null! );
    this._destroying$.complete();
  }

  @HostListener('window:click')
  @HostListener('window:keyup')
  @HostListener('window:mousemove')
  @HostListener('window:wheel')

 resetTimeout() {
    let newLimit = new Date();
    newLimit.setMinutes(newLimit.getMinutes() + 20);
    this.limit = newLimit;
  }
}